import {Model} from '@vuex-orm/core';
import Partner from "./partnerModel";

export default class PartnerContact extends Model {
    static entity = 'partner_contact';
    static primaryKey = 'id_partner_contact';

    static fields() {
        return {
            id_partner_contact: this.number(null),
            id_partner: this.number(null),

            gender: this.attr(null),
            title: this.attr(null),
            first_name: this.attr(null),
            last_name: this.attr(null),
            email: this.attr(null),
            phone_landline: this.attr(null),
            phone_mobile: this.attr(null),
            fax: this.attr(null),
            function: this.attr(null),

            newsletter: this.boolean(false),
            privacy_policy: this.boolean(false),
            invitations_regional: this.boolean(false),
            invitations_national: this.boolean(false),
            central_dispatch_letter: this.boolean(false),
            logo_available: this.boolean(false),

            address: this.attr({
                street: null,
                street_number: null,
                post_code: null,
                city: null,
                country: 49,
            }),

            partner: this.belongsTo(Partner, 'id_partner', 'id_partner'),
        };
    }

}